import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    // Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Container,
    Card,
    styled,
    Stack,
    FormHelperText,
    ListItemButton,
    List,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Chip,
    Checkbox,
    ListItem,
    Tooltip,
    ListItemText,
    FormControlLabel,
    FormGroup
} from '@mui/material';

import {
    LoadingButton
} from '@mui/lab';

import { grey } from "@mui/material/colors";

import { useNavigate, useSearchParams } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";
import { useAuthAccess } from "../../../hooks/useAuthAccess";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { useStateItemTransform } from "../../../hooks/state/loadFrom/documents/useStateItemTransform";

import { useDocuments, documentTypes, targetTypes as documentTargetTypes } from "../../../hooks/api/useDocuments";
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useInventories, inventoriesTypes } from '../../../hooks/api/useInventories';
import { useLocations, locationTypes, targetTypes } from "../../../hooks/api/useLocations";
import { useItems, itemTypes } from "../../../hooks/api/useItems";
import { dependencyModules, dependencyTypes, targetTypes as dependencyTargetTypes } from "../../../hooks/api/useDependencies";
import { useTranslations } from '../../../hooks/useTranslations';

import CommonSectionHeader from "../../common/CommonSectionHeader"
import CommonBreadcumbs from '../../common/CommonBreadcumbs'
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";
import LocationSelector from "../../selector/LocationSelector";

import { CommonIcons, icons } from "../../common/CommonIcons";

import SearchItems from "../../dialog/SearchItems";
// import SearchDocuments from "../../dialog/SearchDocuments";

import {
    validationSchema, initialValues, initialRowValues,
    initialRowInventoryValues, initialRowTransformIntoValues
} from "../../../schema/documents/itemTransformSchema"

import { checkValueExists } from "../../../utils/dataSchema"

import SelectInventory from "./SelectInventory";

import {
    loadFromDocumentTypes,
    LoadFromDocuments
} from "../../dialog/LoadFromDocuments";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const StyledCard2 = styled(Card)(({ theme }) => ({
    padding: theme.spacing(0)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function NewItemTransform({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const navigate = useNavigate()
    // const [searchParams, setSearchParams] = useSearchParams()

    const { authData, getAvailableLocations } = useAuthAccess();
    const { getLocationIds, setLocationIds, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.itemTransform.id)

    const { setSystemLoading } = useAppContextFeatures();
    
    const { isLoading: isLoadingCreate, create, filterOperatorTypes } = useDocuments({ 
        documentType: documentTypes.itemTransform, 
        targetType: documentTargetTypes.itemTransform
    })

    const { list: listInventories } = useInventories({ inventoriesType: inventoriesTypes.inventory })
    const { list: listLocations } = useLocations({ locationType: locationTypes.rack, targetType: targetTypes.rack })
    const { list: listUoms, get: getProduct } = useItems({ itemType: itemTypes.uom })

    const [selectLocationIds, setSelectLocationIds] = useState()
    const { updateFormikState, getFormikDependencyStates } = useStateItemTransform()

    const availableLocations = getAvailableLocations();

    const [dataRacks, setDataRacks] = useState([])
    // const [dataUoms, setDataUoms] = useState([])
    const [dataItemUoms, setDataItemUoms] = useState([])

    const [open, setOpen] = useState(false)

    const [loadDocumentConfig, setLoadDocumentConfig] = useState({
        show: false,
        documentId: loadFromDocumentTypes.itemTransform.id,
        documentType: loadFromDocumentTypes.itemTransform.type,
        keyword: ""
    })

    const fetchProduct = async ({ productId, index }) => {

        setSystemLoading(true)

        try {

            let props = {
                id: productId,
                itemType: itemTypes.product
            }

            let { data } = await getProduct(props);

            // console.log('data --> ', data.items)

            if (data?.items) {
                setDataItemUoms(
                    dataItemUoms.concat(data.items)
                )
            }

            setSystemLoading(false)

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    const fetchRacks = async ({ locationId }) => {

        setSystemLoading(true)

        try {

            let props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "rack_name",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: "location_id",
                        operator: filterOperatorTypes.eq,
                        value: locationId
                    }
                ],
                // dataTypes: ["group_slot_batch"]
            }

            props.parentId = locationId
            props.locationType = locationTypes.rack

            let response = await listLocations(props);

            setSystemLoading(false)

            setDataRacks(response?.data?.racks ? response?.data?.racks : [])

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    const getTransformIntoUoms = ({ productId, excludeItemId = '' }) => {

        if (dataItemUoms.length <= 0) return []

        let data = dataItemUoms.filter(i => i.product_id === productId)

        let availableUoms = [];

        if (data.length && excludeItemId !== '') {
            availableUoms = data.filter(i => i.id !== excludeItemId)
        }

        let returnData = availableUoms.map(i => {

            // check is default uom
            let isDefaultUom = checkIsDefaultUom({ productId, checkItemId: i.id })

            // let label = `${i.uom_name}`; // ${isDefaultUom ? ` (Default)` : ``}`

            return {
                id: i?.uom_id,
                name: i?.uom_name,
                transformRatio: i?.transform_ratio,
                itemId: i.id,
                productId: i.product_id,
                isDefaultUom: isDefaultUom?.isDefault
            }
        })

        return returnData

    }

    const onSubmit = async (currentValues) => {

        try {

            console.log('curren tVal', currentValues);

            const document = {
                doc_date: currentValues.documentDate.format("YYYY-MM-DD"),
                doc_remark: currentValues.remark,
            }

            const props = {
                location_id: currentValues.locationId
            }

            // const dependencies = [
            //     {
            //         scope: dependencyModules.document,
            //         target: dependencyTargetTypes.delivery,
            //         target_id: "915",
            //         type: dependencyTypes.reference
            //     }
            // ]

            let items = [];

            currentValues.rows.forEach(i => {

                let deductions = [];

                let item = {
                    id: i?.itemId,
                    code: i?.code,
                    name: i?.name,
                    description: i?.description,
                    // qty: i?.qty,
                    uom_lbl: i?.uomName,
                    uom: i?.uomId,
                    price: i?.price
                }


                let transformItem = {
                    ...item,
                    qty: parseFloat(i?.transformToFinalQty),
                    addition: {
                        slot_id: i?.transformToSlotId,
                        custom_batch_no: i?.transformToBatchNo ? i.transformToBatchNo : "",
                        expiry_date: i?.transformToExpiryData ? i.transformToExpiryData.format("YYYY-MM-DD") : ""
                    }
                }


                i?.inventory.forEach(e1 => {
                    deductions.push({
                        ...item,
                        qty: parseFloat(e1?.qty.value),
                        slot_id: e1.slotId,
                        custom_batch_no: e1?.customBatchNo,
                        expiry_date: e1?.expiryDate
                    })
                })

                items.push({
                    force_transform: 1, // always force
                    deductions,
                    transform_item: transformItem
                })

            })

            let data = {
                document,
                props,
                items,
                ...getFormikDependencyStates({ values })
            }

            const response = await create({ data });

            console.log('response', response)

            promptMessage(true, `${response?.message}`)

            navigate(getRoute("documents/itemTransform"))

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit
    });

    const {
        values,
        errors,
        touched,
        handleSubmit,
        handleChange,
        setFieldValue
    } = formik

    const updateDefaultFields = () => {

        // update the auth data
        // setFieldValue("retailOutletUserId", authData?.profile?.user?.id)

        // get use the parent user id
        setFieldValue('userId', authData?.profile?.parent_user_id)

        if (selectLocationIds && selectLocationIds.length) {
            const check = availableLocations.filter(i => i.id === selectLocationIds[0])
            // console.log('check', check)
            if (check.length) {

                // use the selected one branch location id
                setFieldValue('shippingBranchId', check[0].branch_id)

                // use the selected one brandh billing branch id
                setFieldValue('billingBranchId', check[0].billing_branch_id)

                fetchRacks({ locationId: selectLocationIds[0] })
                // fetchUoms()

            }

        }

    }

    useEffect(() => {

        updateDefaultFields()

    }, [selectLocationIds])

    useEffect(() => {

        const currentLocationIds = getLocationIds();

        setSelectLocationIds(currentLocationIds)

        if (currentLocationIds.length > 0) {
            // console.log('currentLocationIds', currentLocationIds, availableLocations)

            // get the location information
            const loc = availableLocations.filter(item => item.id === currentLocationIds[0])

            if (loc.length) {
                setFieldValue("locationId", loc[0].id)
                setFieldValue("locationName", loc[0].location_name)
            }
        }

    }, [getLocationIds])

    const handleOpenInventorySelection = ({ itemValues, index }) => {

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: t(`selectAvailableInventory`),
            PaperProps: {
                sx: { width: 2 / 5 }
            },
            handleOnClose: () => { },
            ComponentActions:
                <>
                    {/* <Button
                        variant="contained"
                        // color={"primary"}
                        size="small"
                    // onClick={() => openNew({ row, rackData })}
                    >
                        New Validation
                    </Button> */}
                </>,
            ComponentBody:
                <>
                    <SelectInventory
                        // row={row}
                        locationId={values?.locationId}
                        selectedInventory={itemValues.inventory}
                        rowIndex={index}
                        productId={itemValues?.productId}
                        itemId={itemValues?.itemId}
                        handleOnConfirm={({ productId, rowIndex, values }) => {
                            closeCustomDrawer();

                            let inventory = values.rows.map(i => {
                                return {
                                    batchId: i.batchId,
                                    slotId: i.slotId,
                                    customBatchNo: i.customBatchNo,
                                    expiryDate: i.expiryDate,
                                    qty: i.qty,
                                    label: i.label
                                }
                            })

                            // console.log('productId', productId, rowIndex)
                            console.log('inventory', values)

                            setFieldValue(`rows.${rowIndex}.inventory`, inventory)

                            setFieldValue(`rows.${rowIndex}.transformToItemId`, '') // reset the transform into
                            setFieldValue(`rows.${rowIndex}.transformToUomId`, '') // reset the transform into
                            setFieldValue(`rows.${rowIndex}.transformToUomName`, '') // reset the transform into
                            setFieldValue(`rows.${rowIndex}.transformInto`, []) // reset the transform into 

                            handleChangeRowInventorySelection({ index: rowIndex, productId })

                        }}
                    />
                </>
        })

    }

    const handleChangeRowInventorySelection = ({ index, productId }) => {

        // if (values.rows.length) {

        // values.rows.forEach((i, index) => {

        // if (i.inventory.length === 1) {
        // check the product id already query
        const checkDup = dataItemUoms.filter(i2 => i2.product_id === productId)

        // console.log('i', productId, checkDup)

        if (checkDup.length <= 0) {
            // if (i?.productId) {
            fetchProduct({
                index,
                productId
            })
            // }
        }

        // }

        // })

        // }

    }

    const getDefaultItemUom = ({ productId }) => {

        const lists = dataItemUoms.filter(i => i.product_id === productId)

        let isDefault = false
        let item = {}

        if (lists.length) {

            const a = lists.filter(i => i.default_uom_item_id === i.id)

            if (a.length) {
                isDefault = true
                item = a[0]
            }

        }

        return {
            isDefault,
            item: {
                productId: item?.product_id,
                itemId: item?.id,
                uomId: item?.uom_id,
                uomName: item?.uom_name,
                transformRatio: item?.transform_ratio
            }
        }

    }

    const checkIsDefaultUom = ({ productId, checkItemId }) => {

        const lists = dataItemUoms.filter(i => i.product_id === productId)

        let isDefault = false
        let checkItemArray = lists.filter(i => i.id === checkItemId)

        let item = checkItemArray.length ? checkItemArray[0] : {}

        if (lists.length) {

            // get default uom settings
            const defaultUomItemId = lists[0].default_uom_item_id

            if (defaultUomItemId === checkItemId) {

                const defaultUomItem = dataItemUoms.filter(i => i.id === checkItemId)

                if (defaultUomItem.length) {
                    isDefault = true
                }

            }

        }

        return {
            isDefault,
            item: {
                productId: item?.product_id,
                itemId: item?.id,
                uomId: item?.uom_id,
                uomName: item?.uom_name,
                transformRatio: item?.transform_ratio
            }
        }

    }

    const getRowTotalInventoryQty = ({ index }) => {
        return values.rows[index].inventory.reduce((total, e) => total + parseFloat(e.qty.value), 0)
    }

    const updateStateTransformInto = ({ index, transformToItem }) => {

        const getStateItem = ({ item }) => {
            return {
                ...initialRowTransformIntoValues,
                isDefaultUom: item.isDefault,
                ...item.item
            }
        }

        const getTransformRation = (item) => {
            return parseFloat(item?.transformRatio)
        }

        const formatQty = (val) => {
            return val.toFixed(2)
        }

        let itemValues = (values.rows[index] !== undefined) ? values.rows[index] : {};

        // console.log('itemValues', itemValues)

        let defaultUomItemId = itemValues?.defaultUomItemId

        let itemStates = [];

        // for the first index
        // check the from item is default
        let checkDefault1 = checkIsDefaultUom({ productId: itemValues.productId, checkItemId: itemValues.itemId })

        // console.log('checkIsDefaultUom1 ---> ', checkDefault1)

        itemStates.push(
            getStateItem({ item: checkDefault1 })
        )

        // for the transform into
        // check the from item is default
        let checkDefault2 = checkIsDefaultUom({ productId: itemValues.productId, checkItemId: transformToItem.itemId })

        // console.log('checkIsDefaultUom2 ---> ', checkDefault2, transformToItem.itemId, transformToItem.name)

        itemStates.push(
            getStateItem({ item: checkDefault2 })
        )

        // check 1 & 2 is not default - need to get default and push to middle
        if (checkDefault1.isDefault === false && checkDefault2.isDefault === false) {

            // get the default uom 
            const defaultUom = getDefaultItemUom({ productId: itemValues.productId })

            itemStates.splice(1, 0, getStateItem({ item: defaultUom }));

            // console.log('defaultUom', defaultUom, itemStates)

        }

        // total Current inventory selection qty sum up
        let totalInventoryQty = getRowTotalInventoryQty({ index })

        //
        // Total Inventory Qty: 30

        // 1. Situation 1(Default[1] -> Normal[20:def]) - divide
        // 1. 30 / 20
        // 2. Situation 2(Normal[20:def] -> Default[1])
        // 1. 30 x 20
        // 3. Situation 3(Normal[20:def] -> Default[1] -> Normal[30:def])
        // 1. 30 x 20 / 30

        // console.log('itemStates', itemStates)

        // calculation for the transform ratio
        if (itemStates[0].isDefaultUom === true) { // check the situation #1

            let calculatedQty = parseFloat(totalInventoryQty / getTransformRation(itemStates[1])) // divide
            calculatedQty = formatQty(calculatedQty)

            itemStates[1].calculation = {
                baseQty: totalInventoryQty,
                // operation: "/",
                // targetQty: itemStates[1].transformRatio,
                calculatedQty,
                formulaDisplay: `${totalInventoryQty} / ${getTransformRation(itemStates[1])} = ${calculatedQty}`
            }

        } else { // for the situation #2 or #3

            let calculatedQty = parseFloat(totalInventoryQty * getTransformRation(itemStates[0])) // multiply
            calculatedQty = formatQty(calculatedQty)

            itemStates[1].calculation = {
                baseQty: totalInventoryQty,
                // operation: "x",
                // targetQty: itemStates[0].transformRatio,
                calculatedQty,
                formulaDisplay: `${totalInventoryQty} * ${getTransformRation(itemStates[0])} = ${calculatedQty}`
            }

            // check if there is no3 array - mean is situation #3
            if (itemStates.length > 2) {
                let bringForwardQty = calculatedQty
                calculatedQty = parseFloat(bringForwardQty / getTransformRation(itemStates[2])) // multiply

                itemStates[2].calculation = {
                    baseQty: bringForwardQty,
                    // operation: "/",
                    // targetQty: itemStates[0].transformRatio,
                    calculatedQty,
                    formulaDisplay: `${bringForwardQty} / ${getTransformRation(itemStates[2])} = ${calculatedQty}`
                }
            }

        }


        setFieldValue(`rows.${index}.transformInto`, itemStates)

        // console.log('getRowTotalInventoryQty', totalInventoryQty)

        setFieldValue(`rows.${index}.inventoryTotalQty`, parseFloat(totalInventoryQty))

        let finalQty = parseFloat(itemStates[itemStates.length - 1].calculation.calculatedQty)

        setFieldValue(`rows.${index}.transformToFinalQty`, finalQty)
        setFieldValue(`rows.${index}.transformToFinalCalculatedQty`, finalQty)

    }

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            props.push({
                displayText: t("loadFrom"),
                onClick: () => {

                    // check the location is selected - valid
                    if (validateLocationSelection() === false) {
                        promptMessage(false, t(`pleaseSelectAnyLocation`))
                        return false;
                    }

                    setLoadDocumentConfig(prev => ({ ...prev, show: true }))

                    return true;
                }
            })
        }

        return props
    }

    const validateLocationSelection = () => {
        // return (selectLocationIds && selectLocationIds.length === 1)
        const selected = getLocationIds()
        return selected && selected.length === 1
    }

    const updateStateFromSearchDocument = (props) => {

        try {

            // check the location is selected - valid
            if (validateLocationSelection() === false) {
                promptMessage(false, t(`pleaseSelectAnyLocation`))
                return false;
            }

            updateFormikState({
                data: props?.data,
                routeType,
                setFieldValue,
            })


        } catch (error) {
            promptMessage(false, `Load failed : ${error}`)
        }

        return true;
    }

    const handleAddItem = ({ rows, setFieldValue }) => {

        rows.push(initialRowValues);
        setFieldValue('rows', rows)

    }

    const handleRemoveItem = ({ rows, index, setFieldValue }) => {

        const currentLine = rows ? rows.length : 0;

        if (currentLine <= 1) {
            promptMessage(false, t(`ItemsAtLeastHave1Row`))
            return false;
        }

        const newRows = rows.filter((i, ind) => ind !== index)

        // rows.remove(index);
        setFieldValue('rows', newRows)

        return true;

    }

    // // able to filter out the inventory batches been selected even for the same uom id
    // const getAvailableInventoryBatches = ({ index, itemId }) => {

    //     const selected = getInventoryBatchesByItemId({ itemId, selectedIndexNo: index })

    //     // remove the selection if the index selected
    //     const showSelected = selected.filter(i => i.selectedIndexNo === false || i.selectedIndexNo === index)

    //     return showSelected;
    // }

    const RenderSectionDivider = ({ title, customStyle }) => {
        return <Divider sx={{ mx: -2, ...customStyle }}><Typography sx={{ fontSize: 14, color: grey[600] }}>{title}</Typography></Divider>
    }

    const RenderTransformIntoRowCalculation = ({ itemValues, index }) => {

        if (!itemValues?.transformInto) return <></>
        if (itemValues.transformInto.length <= 0) return <></>

        return (
            <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{

                    backgroundColor: grey[100],
                    borderRadius: 1,
                    px: 1,
                    py: 1
                }}
            >
                {
                    itemValues.transformInto.map((i, ind) => {

                        let qty = 0
                        let tooltipMessage = '';
                        let uomName = i?.uomName;

                        if (i?.calculation) {
                            qty = i?.calculation?.calculatedQty
                            tooltipMessage = i?.calculation?.formulaDisplay
                        } else { // for first one
                            qty = getRowTotalInventoryQty({ index })
                            tooltipMessage = t('selectedInventoryQty');
                        }

                        return (
                            <Box
                                key={ind}
                                display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"center"}
                                alignItems={"center"}
                                textAlign={"center"}
                                sx={{
                                    flex: 1,
                                    // backgroundColor: 'yellow',
                                    // mr: 1,
                                    position: 'relative'
                                }}
                            >
                                <Box
                                    display={"flex"}
                                    flexDirection={"column"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    textAlign={"left"}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: '800',
                                            textAlign: 'center'
                                        }}
                                    >
                                        {qty}
                                    </Typography>
                                    <Tooltip title={tooltipMessage}>
                                        <Box
                                            display={"flex"}
                                            flexDirection={"row"}
                                            justifyContent={"center"}
                                            alignItems={"center"}
                                            textAlign={"center"}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: 13
                                                }}
                                            >
                                                {uomName}
                                            </Typography>
                                            <CommonIcons name={icons.info} sx={{ width: 15, height: 15 }} />
                                        </Box>
                                    </Tooltip>
                                </Box>
                                {
                                    ind < (itemValues.transformInto.length - 1) &&
                                    <CommonIcons name={icons.chevronRight} sx={{ position: 'absolute', top: 13, right: 0 }} />
                                }
                            </Box>
                        )
                    })
                }
            </Box>
        )

    }

    const RenderTextBox = ({ itemValues, itemErrors, index }) => {
        return (
            <>
                <Grid item xs={6} sx={{ mt: 1 }}>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    // defaultChecked
                                    size="small"
                                    value={1}
                                    checked={
                                        Boolean(itemValues.transformForceMode)
                                    }
                                    onChange={(e) => {
                                        let isCheck = e.target.checked

                                        setFieldValue(
                                            `rows.${index}.transformForceMode`,
                                            isCheck
                                        )

                                    }}
                                />
                            }
                            label={
                                <Typography
                                    sx={{
                                        fontSize: 13
                                    }}
                                >
                                    {t('customFinalQty')}
                                </Typography>
                            }
                        />
                    </FormGroup>
                </Grid>
                <Grid item xs={6} sx={{ mt: 1 }}>

                    <TextField
                        disabled={
                            !Boolean(itemValues.transformForceMode)
                        }
                        inputProps={{
                            style: {
                                textAlign: "right"
                            }
                        }}
                        margin="dense"
                        size="small"
                        fullWidth
                        name={`rows.${index}.transformToFinalQty`}
                        label={t(`finalQty`)}
                        type="text"
                        variant="outlined"
                        value={
                            Boolean(itemValues.transformForceMode) ? itemValues?.transformToFinalQty : itemValues?.transformToFinalCalculatedQty
                        }
                        onChange={handleChange}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    / {itemValues?.transformToUomName}
                                </InputAdornment>
                            )
                        }}

                        onFocus={event => {
                            event.target.select();
                        }}

                        error={Boolean(itemErrors?.transformToFinalQty)}
                        helperText={itemErrors?.transformToFinalQty}
                    />
                </Grid>
            </>

        )
    }

    const RenderTransformInto = ({ item, index, itemErrors, itemTouched, itemValues }) => {

        // check the prev selection needed
        // if (itemValues.inventory.length <= 0) return <></>

        let availableUoms = getTransformIntoUoms(
            {
                productId: itemValues.productId,
                excludeItemId: itemValues.itemId
            }
        )

        // console.log('availableUoms', availableUoms)

        return (
            <StyledCard>

                <RenderSectionDivider
                    title={
                        `${t('transformInto')} ${itemValues?.transformToUomName ? "(".concat(itemValues.transformToUomName, ")") : ''}`
                    }
                />

                <Grid container>
                    <Grid item xs={12}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={Boolean(itemErrors?.transformToUomId)}
                        >
                            <InputLabel id="custom_batch_no">{t('uom')}</InputLabel>
                            <Select
                                labelId="custom_batch_no"
                                label={t('uom')}
                                name={`rows.${index}.transformToUomId`}
                                onChange={(e) => {
                                    let val = e.target.value

                                    const selected = availableUoms.filter(i => i.id === val)

                                    // console.log('va', val, selected)

                                    if (selected.length) {

                                        setFieldValue(`rows.${index}.transformToUomId`, val)
                                        setFieldValue(`rows.${index}.transformToUomName`, selected[0].name)
                                        setFieldValue(`rows.${index}.transformToItemId`, selected[0].itemId)

                                        updateStateTransformInto({ index, transformToItem: selected[0] })
                                    }

                                }}
                                value={
                                    checkValueExists({
                                        searchFieldId: "id",
                                        // searchByIndex: true,
                                        dataSearch: availableUoms,
                                        valueToCompare: itemValues?.transformToUomId
                                    })
                                }
                                sx={{
                                    textAlign: 'left'
                                }}
                            >
                                {
                                    availableUoms.map((i, ind) => {

                                        let display = `${i.name}`

                                        if (i.isDefaultUom) {
                                            display = `${display} (Default)`
                                        }

                                        display += ` (Ratio : ${i.transformRatio})`

                                        return (
                                            <MenuItem value={i.id} key={ind}>{i.id} - {display}</MenuItem>
                                        )
                                    })
                                }

                            </Select>
                            <FormHelperText>
                                {itemErrors?.transformToUomId}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        {
                            RenderTransformIntoRowCalculation({ itemValues, index })
                        }
                    </Grid>

                    {
                        (itemValues?.transformToUomName) &&

                        RenderTextBox({
                            itemValues,
                            itemErrors,
                            index
                        })


                    }

                </Grid>

            </StyledCard>
        )
    }

    const RenderAllocateTo = ({ item, index, itemErrors, itemTouched, itemValues }) => {

        // check the prev selection needed
        // if (itemValues.inventory.length <= 0) return <></>

        const getAvailableSlots = ({ rackId }) => {

            const selectedRack = dataRacks.filter(i => i.id === rackId)

            let slots = selectedRack.length ? selectedRack[0].slots : []

            let availableSlots = []

            if (Object.keys(slots).length) {

                Object.keys(slots).forEach((e1) => {
                    availableSlots.push({
                        id: e1,
                        name: slots[e1]
                    })
                })
            }

            return availableSlots

        }

        return (
            <StyledCard>

                <RenderSectionDivider title={t(`allocation`)} />

                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={Boolean(itemErrors?.transformToRackId)}
                        >
                            <InputLabel id="transformToRackId">{t('rack')}</InputLabel>
                            <Select
                                size="small"
                                margin="dense"
                                labelId="transformToRackId"
                                label={t("rack")}
                                name={`rows.${index}.transformToRackId`}
                                onChange={handleChange}
                                value={
                                    checkValueExists({
                                        searchFieldId: "id",
                                        // searchByIndex: true,
                                        dataSearch: dataRacks,
                                        valueToCompare: itemValues?.transformToRackId
                                    })
                                }
                                sx={{
                                    textAlign: 'left'
                                }}
                            >
                                {
                                    dataRacks && dataRacks.map((i, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={i.id}
                                                sx={{
                                                    textTransform: 'capitalize'
                                                }}
                                            >
                                                {i.rack_name}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            <FormHelperText>
                                {itemErrors?.transformToRackId}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={Boolean(itemErrors?.transformToSlotId)}
                        >
                            <InputLabel id="transformToSlotId">{t('slot')}</InputLabel>
                            <Select
                                size="small"
                                margin="dense"
                                labelId="transformToSlotId"
                                label={t("slot")}
                                name={`rows.${index}.transformToSlotId`}
                                onChange={handleChange}
                                value={
                                    checkValueExists({
                                        searchFieldId: "id",
                                        // searchByIndex: true,
                                        dataSearch: getAvailableSlots({ rackId: itemValues?.transformToRackId }),
                                        valueToCompare: itemValues?.transformToSlotId
                                    })
                                }
                                sx={{
                                    textAlign: 'left'
                                }}
                            >
                                {
                                    getAvailableSlots({ rackId: itemValues?.transformToRackId }).map((i, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={i.id}
                                                sx={{
                                                    textTransform: 'capitalize'
                                                }}
                                            >
                                                {i.name}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            <FormHelperText>
                                {itemErrors?.transformToSlotId}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            margin="dense"
                            size="small"
                            fullWidth
                            name={`rows.${index}.transformToBatchNo`}
                            label={t(`newBatchNo`)}
                            type="text"
                            variant="outlined"
                            // value={itemValues?.qty? itemValues.qty : ""}
                            values={itemValues?.transformToBatchNo ? itemValues.transformToBatchNo : ""}
                            onChange={handleChange}
                            error={Boolean(itemErrors?.transformToBatchNo)}
                            helperText={itemErrors?.transformToBatchNo}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DatePickerComponent
                            config={{
                                name: `rows.${index}.transformToExpiryData`,
                                label: t("expiryDate")
                            }}
                            formik={{
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue
                            }}
                            sx={{
                                width: '100%'
                            }}
                        />
                    </Grid>
                </Grid>

            </StyledCard>
        )
    }

    // const RenderMenuItem = ({ item, index }) => {
    //     return (
    //         <MenuItem
    //             key={index}
    //             value={item.batchId}
    //             sx={{
    //                 textTransform: 'capitalize',
    //                 px: 1.5,
    //                 fontSize: 14,
    //                 width: '100%'
    //             }}
    //             disableGutters
    //             divider
    //         >
    //             <Grid container>
    //                 <Grid item xs={5} sm={5} md={5} display={"flex"} alignItems={"center"} justifyContent={"flex-start"}>
    //                     <RenderDisplayText text={item?.labels?.customBatchNo} />
    //                 </Grid>
    //                 <Grid item xs={3} sm={3} md={3} display={"flex"} alignItems={"center"} justifyContent={"flex-start"}>
    //                     <RenderDisplayText text={item?.labels?.expiryDate} />
    //                 </Grid>
    //                 <Grid item xs={2} sm={2} md={2} display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
    //                     <RenderDisplayText text={`${item?.labels?.rackName}/${item?.labels?.slotName}`} />
    //                 </Grid>
    //                 <Grid item xs={2} sm={2} md={2} display={"flex"} justifyContent={"flex-end"} alignItems={"flex-end"} sx={{ pr: 1 }}>
    //                     <RenderDisplayText text={item?.labels?.totalRemainQty} />
    //                 </Grid>
    //             </Grid >
    //         </MenuItem>
    //     )
    // }

    const RenderSelectionEmpty = ({ itemValues, index }) => {
        return (
            <StyledCard2
                sx={{
                    backgroundColor: grey[100]
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        minHeight: 100,
                    }}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Typography
                        sx={{
                            fontSize: 14
                        }}
                    >
                        {t('youHaveNotSelectAnyInventoryYet')}
                    </Typography>
                    <Button
                        variant="outlined"
                        sx={{
                            mt: 1
                        }}
                        onClick={() => handleOpenInventorySelection({ itemValues, index })}
                    >
                        {t('selectInventory')}
                    </Button>
                </Box>
            </StyledCard2>
        )
    }

    const RenderInventorySelection = ({ itemValues, index }) => {

        if (itemValues.inventory.length <= 0) {
            return <RenderSelectionEmpty itemValues={itemValues} index={index} />
        }

        return (
            <Box>
                <Box>
                    {
                        itemValues.inventory.map((i5, index5) => {
                            return (
                                <ListItem
                                    key={index5}
                                    disableGutters
                                    disablePadding
                                    divider
                                    sx={{
                                        py: 0.5
                                    }}
                                >
                                    <Box
                                        display={"flex"}
                                        flexDirection={"row"}
                                        justifyContent={"space-between"}
                                        alignItems={"center"}
                                        sx={{
                                            width: '100%'
                                        }}
                                    >
                                        <Typography
                                            sx={{ fontSize: 13 }}
                                        >
                                            {i5?.label}
                                        </Typography>
                                        <Typography
                                            sx={{ fontSize: 13 }}
                                        >
                                            {`${i5?.qty.value} ${itemValues?.uomName}`}
                                        </Typography>
                                    </Box>
                                </ListItem>
                            )
                        })
                    }
                </Box>
                {
                    (itemValues.inventory.length > 0) &&
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={() => {
                            handleOpenInventorySelection({ itemValues, index })
                        }}
                        sx={{
                            mt: 1
                        }}
                    >
                        <CommonIcons name={icons.edit} />
                        {t('modifySelection')}
                    </Button>
                }
            </Box>
        )
    }

    const RenderInventory = (props) => {

        const { item, index, itemErrors, itemTouched, itemValues } = props

        return (
            <StyledCard>

                <RenderSectionDivider title={t(`inventory`)} />

                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <SearchItems
                            id={`rows.${index}.name`}
                            handleOnCancel={() => { }}
                            handleOnSearchChange={(event) => {
                                setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                            }}
                            // handleOnSelect={({ id, item }) => {
                            //     // console.log('id', id, item)
                            //     setFieldValue(`rows.${index}.itemId`, item?.id)
                            //     setFieldValue(`rows.${index}.name`, item?.item_name)
                            //     setFieldValue(`rows.${index}.description`, item?.description)
                            //     setFieldValue(`rows.${index}.code`, item?.code)
                            //     setFieldValue(`rows.${index}.uomName`, item?.uom_name)
                            //     setFieldValue(`rows.${index}.uomId`, item?.uom_id)
                            //     setFieldValue(`rows.${index}.qty`, 1)
                            //     setFieldValue(`rows.${index}.price`, item?.uom_price)
                            // }}
                            handleOnSelect={async ({ id, item }) => {

                                // appendInventoryBatch({ itemId: item?.id, selectedIndexNo: index })

                                console.log('item', item)

                                // console.log('id', id, item)
                                setFieldValue(`rows.${index}.productId`, item?.product_id)
                                setFieldValue(`rows.${index}.itemId`, item?.id)
                                setFieldValue(`rows.${index}.name`, item?.item_name)
                                setFieldValue(`rows.${index}.description`, item?.description)
                                setFieldValue(`rows.${index}.code`, item?.code)
                                setFieldValue(`rows.${index}.uomName`, item?.uom_name)
                                setFieldValue(`rows.${index}.uomId`, item?.uom_id)
                                setFieldValue(`rows.${index}.qty`, 1)
                                setFieldValue(`rows.${index}.price`, item?.uom_price)
                                // setFieldValue(`rows.${index}.inventoryBatches`, inventoryBatches)
                                setFieldValue(`rows.${index}.defaultUomItemId`, item?.default_uom_item_id)

                                setFieldValue(`rows.${index}.inventory`, [])
                                setFieldValue(`rows.${index}.transformInto`, [])

                                setOpen(true)

                            }}
                            textProps={{
                                disabled: true,
                                value: itemValues?.name ? itemValues.name : "",
                                error: Boolean(itemErrors?.name),
                                helperText: itemErrors?.name
                            }}
                        />
                        {
                            itemValues.itemId &&
                            <>
                                <Chip
                                    label={`${itemValues.code} (${itemValues.uomName})`}
                                    variant="outlined"
                                    size="small"
                                />
                                {
                                    itemValues.itemId === itemValues.defaultUomItemId &&
                                    <Chip
                                        label={t(`defaultUom`)}
                                        variant="outlined"
                                        size="small"
                                    />
                                }
                            </>
                        }
                    </Grid>
                </Grid>

                {
                    itemValues?.itemId &&

                    <>
                        <RenderSectionDivider
                            title={`${t('consumption')} (${itemValues?.uomName})`}
                            customStyle={{
                                my: 1
                            }}
                        />

                        <RenderInventorySelection
                            itemValues={itemValues}
                            index={index}
                        />

                        {/* {
                            RenderInventorySelect({
                                ...props,
                            })
                        }

                        <Grid container spacing={0}>
                            {
                                itemValues.inventory.map((i2, index2) => {
                                    return RenderInventoryBatchRow({
                                        index,
                                        index2,
                                        item: i2,
                                        itemTouched,
                                        itemErrors,
                                        itemValuesInventory: itemValues.inventory
                                    })
                                })
                            }
                        </Grid> */}
                    </>

                }


            </StyledCard>
        )
    }

    // const RenderRow = (props) => {

    //     let { item, index } = props

    //     const itemValues = item;
    //     let itemTouched = touched?.rows
    //     let itemErrors = errors?.rows
    //     // const itemTouched = touched?.rows

    //     if (itemTouched) {
    //         itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
    //     }

    //     if (itemErrors) {
    //         itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
    //     }

    //     let data = { ...props }
    //     data.index = index;
    //     data.itemValues = itemValues;
    //     data.itemErrors = itemErrors;
    //     data.itemTouched = itemTouched;

    //     return (

    //         <Grid container spacing={1} >


    //             {/* <Box flexWrap={1}>
    //                 <Typography sx={{ fontSize: 10 }} >
    //                     {
    //                         JSON.stringify(itemValues?.transformInto)
    //                     }
    //                     {
    //                         JSON.stringify(itemValues)
    //                     }
    //                 </Typography>

    //             </Box> */}


    //             <Grid item xs={12} sm={12} md={0.5} display={"flex"} justifyContent={"center"} alignItems={"center"}>
    //                 <IconButton
    //                     aria-label="delete"
    //                     onClick={() => handleRemoveItem({ rows: values.rows, index, setFieldValue })}
    //                     color={"error"}
    //                 >
    //                     <CommonIcons name={icons.remove} />
    //                 </IconButton>
    //             </Grid>

    //             <Grid item xs={12} sm={12} md={4}>

    //                 {
    //                     RenderInventory({ ...data })
    //                 }
    //             </Grid>

    //             <Grid item xs={12} sm={12} md={4}>

    //                 {
    //                     RenderTransformInto({ ...data })
    //                 }

    //             </Grid>

    //             {/* <Grid item xs={12} sm={12} md={3.5}>

    //                 {
    //                     RenderAllocateTo({ ...data })
    //                 }

    //             </Grid> */}

    //         </Grid>
    //     )
    // }

    const RenderRows = () => {

        const rows = values?.rows;

        return (
            <Box
            >

                <Grid container spacing={1}>
                    {
                        rows && rows.length > 0
                        && rows.map((item, index) => {

                            const itemValues = item;
                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            let data = {} // = { ...props }
                            data.index = index;
                            data.itemValues = itemValues;
                            data.itemErrors = itemErrors;
                            data.itemTouched = itemTouched;

                            return (
                                <Grid item key={index} xs={12} sm={12} md={12}>
                                    <StyledCard key={index}>

                                        {/* <RenderRow
                                            item={item}

                                            index={index}
                                        /> */}

                                        <Grid container spacing={1} >

                                            <Grid item xs={12} sm={12} md={0.5} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                                <IconButton
                                                    aria-label="delete"
                                                    onClick={() => handleRemoveItem({ rows: values.rows, index, setFieldValue })}
                                                    color={"error"}
                                                >
                                                    <CommonIcons name={icons.remove} />
                                                </IconButton>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={4}>

                                                {
                                                    RenderInventory({ ...data })
                                                }
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={4}>

                                                {
                                                    RenderTransformInto({ ...data })
                                                }

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={3.5}>

                                                {
                                                    RenderAllocateTo({ ...data })
                                                }

                                            </Grid>

                                        </Grid>

                                    </StyledCard>
                                </Grid>

                            )
                        })
                    }
                    <Grid item xs={12} sm={12} md={12}>
                        <Button
                            variant="outlined"
                            // sx={{ height: '100%', minHeight: 360 }}
                            fullWidth
                            startIcon={<CommonIcons name={icons.plus} />}
                            onClick={() => handleAddItem({ rows: values.rows, setFieldValue })}
                        >
                            {t('addItem')}
                        </Button>
                    </Grid>
                </Grid>

                {/* <Grid container>
                    <Grid item xs={12}>
                        <Divider sx={{ mt: 1, mb: 0 }} />
                    </Grid>
                </Grid> */}

                {/* {
                    RenderSummaryRow()
                } */}

            </Box>
        )
    }

    const RenderFormLocation = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`location`)}
                            subTitle={t(`relatedWarehouseLocationToProcess`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={10.5}>
                        <TextField
                            disabled
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"locationId"}
                            label={t("location")}
                            type="text"
                            variant="outlined"
                            value={values.locationName}
                            error={touched.locationId && Boolean(errors.locationId)}
                            helperText={touched.locationId && errors.locationId}
                        />
                    </Grid>
                    <Grid item md={1.5}>
                        <IconButton
                            color="primary"
                            sx={{
                                // pt: 0
                            }}
                            onClick={() => {
                                setLocationIds([])
                                setFieldValue(`rows`, [initialRowValues])
                            }}
                        >
                            <StyledIcon
                                sx={{
                                    width: 25,
                                    height: 25,
                                    m: 0,
                                    p: 0
                                }}
                            >
                                <CommonIcons name={icons.edit} />
                            </StyledIcon>
                        </IconButton>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                                <DatePickerComponent
                                    config={{
                                        name: "documentDate",
                                        label: t("documentDate")
                                    }}
                                    formik={{
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        setFieldValue
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label={t("remark")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.remark}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        return (
            <form onSubmit={handleSubmit}>

                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>


                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        {
                            RenderFormLocation()
                        }
                    </Grid>

                </Grid>
                {/* <StyledCard sx={{ mt: 1 }}> */}
                <Grid container sx={{ mt: 2 }}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`items`)}
                            subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                        />

                    </Grid>

                    <Grid item xs={12} sm={12} md={12} textAlign={"left"} sx={{ mt: 1 }}>

                        {
                            RenderRows()
                        }

                        {/* <FieldArray
                                    name="rows"
                                    render={(arrayHelpers) => {
                                        
                                        return RenderRow({ values, errors, touched, handleChange, setFieldValue, arrayHelpers})
                                    
                                    }}
                                /> */}
                    </Grid>

                </Grid>
                {/* </StyledCard> */}
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <Button
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                        // loading={isLoadingCreate}
                        >
                            {t('saveChanges')}
                        </Button>
                    </Grid>
                </Grid>

            </form>
        )
    }

    const RenderAll = () => {
        return validateLocationSelection() ?
            (
                RenderForm()
            )
            :
            (
                <LocationSelector
                    config={{
                        title: t("selectOnly1Location"),
                        description: t("youHaveToSelectAnyoneOfTheWarehouseLocationToProceed")
                    }}
                    maxSelect={1}
                    handleOnNext={({ selected }) => {

                        // console.log('selected', selected)

                        setLocationIds([selected[0].id])
                        setFieldValue(`locationId`, selected[0].id)
                        setFieldValue(`locationName`, selected[0].location_name)

                    }}
                />
            )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newItemTransform })
            }

            {/* <Typography
                sx={{
                    fontSize: 10
                }}
            >
                {
                    JSON.stringify(errors)
                }
            </Typography> */}

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("newItemTransform")}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("itemTransforms"),
                        props: {
                            // underline: "hover",
                            href: getRoute('documents/itemTransform')
                        }
                    },
                    {
                        displayText: t("newItemTransform"),
                        props: {
                            // disabled: true,
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {/* {JSON.stringify(values?.rows)} */}
            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderAll()
                    :
                    <CommonRestricted />
            }

            {
                loadDocumentConfig?.show &&

                <LoadFromDocuments
                    fromDocumentId={loadDocumentConfig?.documentId}
                    fromDocumentType={loadDocumentConfig?.documentType}
                    show={loadDocumentConfig?.show}
                    filledSearchKeyword={loadDocumentConfig?.keyword}
                    handleOnCancel={() => {
                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))
                    }}
                    handleOnSelect={(props) => {

                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))

                        // load the data into the state
                        updateStateFromSearchDocument(props)

                    }}
                />
            }

        </Box>
    )

}